import styled, { keyframes } from 'styled-components';
import { variables } from '../../../styles/variables';

interface Props {
  opened: boolean;
}

const animatedOpen = keyframes`
  from {
    max-height: 0;
    overflow-y: hidden;
  }
  to {
    max-height: 265px;
  }
`;

const animatedIcon = keyframes`
  0% {
    transform: rotate(180deg);
  }
  50% {
    transform: rotate(90deg);
  }
  100% {
    transform: rotate(0deg);
  }
`;

export const FilterBoxContainer = styled.div`
  display: ${(props: Props): string => props.opened ? 'block' : 'none'};
  border-radius: 21px;
  box-shadow: -1px 1px 12px -4px rgba(0, 0, 0, 0.4);
  background-color: ${variables.colorWhite};
  padding: 10px 30px;
  width: max-content;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  > div {
    animation-name: ${(props: Props) => props.opened ? animatedOpen : null};
    animation-duration: 0.4s;
    animation-timing-function: ease-out; 
    max-height: 265px;
    width: 100%;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 4px;
      border-color: ${variables.colorWhite};
      background: ${variables.colorBorder};
    }
    &::-webkit-scrollbar-thumb {
      background: ${variables.colorDecorator};
    }
  }
  h4 {
    font-size: 1.6rem;
    text-transform: uppercase;
    color: ${variables.colorDecorator};
    img {
      margin-left: 15px;
      animation: ${animatedIcon} 0.3s ease-out;
    }
  }
  @media (max-width: 768px), (max-height: 412px) {
    padding: 10px 15px;
    h4 {
      img {
        margin-left: 10px;
      }
    }
  }
`;
